export default "//static.tradera.net/touchweb/static/output/images/save-search.57e36711.png";